import { render, staticRenderFns } from "./quoteDetails.vue?vue&type=template&id=130c55cb&scoped=true"
import script from "./quoteDetails.vue?vue&type=script&lang=js"
export * from "./quoteDetails.vue?vue&type=script&lang=js"
import style0 from "./quoteDetails.vue?vue&type=style&index=0&id=130c55cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c55cb",
  null
  
)

export default component.exports